/* istanbul ignore file */
/**
 * Created by rathompson on 7/22/22
 * File: APITable
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import PermissionsTable from '../../../common/permissionsTable/PermissionsTable'
import { VFC, useMemo } from 'react'
import type { IAM_Permission } from '../../../../../common/reducers/types/IAMReducer.types'
import type { TableState } from '@panwds/react-table'
import buildPermissionsTree from '../../../../utils/buildPermissionTree'

const APITable: VFC<{
  data: IAM_Permission[],
  tableInstanceRef: any,
  tableRef: any,
  tableState: TableState<IAM_Permission>
  enablePagination: boolean,
  viewOnly?: boolean
  expanded?: boolean
}> = ({
  data = [],
  tableInstanceRef = {},
  tableRef = {},
  tableState = {},
  enablePagination = true,
  viewOnly = false,
  expanded = true
}) => {

  const resolvedData = useMemo(() => {
    const {
      locked,
      unlocked
    } = data.reduce((obj: { locked: IAM_Permission[], unlocked: IAM_Permission[] }, permission) => {
      const { locked, unlocked } = obj
      if (!!permission?.locked) {
        locked.push(permission)
      }
      else {
        unlocked.push(permission)
      }
      return obj
    }, { locked: [], unlocked: [] })
    const permissions = unlocked.filter((permission: IAM_Permission) => !locked.find(({ name }) => permission?.name === name))
    return [...permissions, ...locked]
  }, [data])

  const permissions = useMemo(() => buildPermissionsTree(resolvedData), [resolvedData])

  return (
    <PermissionsTable
      data={permissions}
      tableRef={tableRef}
      tableInstanceRef={tableInstanceRef}
      enablePagination={enablePagination}
      enableSearch={false}
      tableState={tableState}
      enableRowSelect={!viewOnly}
      useLocks
      expanded={expanded}
    />
  )
}

export default APITable
